<div *ngIf='(vm$ | async) as vm'>

    <app-page-header [vm]="vm" title='NetJets Crossroads' [canGoBack]="true" [canRefresh]="true"
        (refreshClick)="refreshPage()"></app-page-header>

    <!-- body -->
    <div *ngIf="!vm.workingText && !vm.errorText && vm.data">

        <!-- stat panel -->
        <div class="row pt-3 animated fadeIn" *ngIf="vm.statPanelVm as svm">
            <div class="col-md-12" >
                <mdb-card narrower="true" cascade="true">
                    <app-card-header [title]="svm.data.title" [headingSize]="3"></app-card-header>
                    <mdb-card-body cascade="true">
                        <div class="row">
                            <div class="col-md-3 pb-3" *ngFor="let s of svm.data.stats">
                                <h5>
                                    <strong>{{s.statName}}:</strong>
                                    <small class="text-muted pl-1">{{s.intValue}}</small>
                                </h5>
                            </div>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>

        <!-- tabs -->
        <div class="row pt-3">
            <div class="col-md-12">

                <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'">
                    
                    <!-- mismatch -->
                    <mdb-tab heading="Invalid" *ngIf="vm.data.mismatchPanel as p">
                        <div class="row">
                            <div class="col-md-6 animated fadeIn pb-3" *ngFor="let s of p.sections">
                                <mdb-card narrower="true" cascade="true">
                                    <app-card-header [title]="s.orderNumber" [headingSize]="3" [subTitle]="s.subTitle"
                                        [dangerText]="s.dangerText"></app-card-header>
                                    <mdb-card-body cascade="true">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <a href="{{s.crossroadsUrl}}" target="_blank">View Order</a>
                                            </div>
                                            <div class="col-md-4">
                                                <span>{{s.confirmNumber}}</span>
                                            </div>
                                        </div>
                
                                        <div class="row">
                                            <div class="col-md-12">
                                                <table mdbTable striped="true" small="true">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Field</th>
                                                            <th scope="col">Crossroads</th>
                                                            <th scope="col">Santa Cruz</th>
                                                        </tr>
                                                    </thead>
                
                                                    <tbody>
                                                        <tr mdbTableCol *ngFor="let f of s.fields">
                                                            <td>{{f.name}}</td>
                                                            <td>{{f.crossroadsValue}}</td>
                                                            <td>{{f.santaCruzValue}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="d-flex align-items-center" style="height: 50px">
                                                    <div *ngIf="s.completedText" class="d-flex justify-content-start">
                                                        <mdb-badge pill="true" success="true">{{s.completedText}}</mdb-badge>
                                                    </div>
                                                    <div *ngIf="!s.completedText && s.ignoreEntryStarted && !s.cmdExecutingText"
                                                        class="d-flex flex-grow-1">
                                                        <input mdbInput type="text" id="ignore" placeholder="comment"
                                                            class="form-control" [(ngModel)]="s.ignoreComment">
                                                        <mdb-badge class="align-self-center" *ngIf="s.cmdExecutedErrorText" pill="true"
                                                            danger="true" [mdbTooltip]="s.cmdExecutedErrorText">!</mdb-badge>
                                                        <button mdbBtn color="success" type="button" outline="true" rounded="true"
                                                            size="sm" mdbWavesEffect [disabled]="s.ignoreEntrySubmitting"
                                                            (click)="mismatchIgnoreClick(vm, s.orderNumber, 2)">Accept</button>
                                                        <button mdbBtn color="danger" type="button" outline="true" rounded="true"
                                                            size="sm" mdbWavesEffect [disabled]="s.ignoreEntrySubmitting"
                                                            (click)="mismatchIgnoreClick(vm, s.orderNumber, 3)">Cancel</button>
                                                    </div>
                                                    <div *ngIf="s.cmdExecutingText" class="d-flex justify-content-start">
                                                        <span>{{s.cmdExecutingText}}</span>
                                                    </div>
                                                    <div *ngIf="!s.completedText && !s.ignoreEntryStarted && !s.cmdExecutingText"
                                                        class="d-flex justify-content-start">
                                                        <button mdbBtn color="default" type="button" outline="true" rounded="true"
                                                            size="sm" mdbWavesEffect [disabled]="!vm.actionsAllowed"
                                                            (click)="mismatchValidateClick(vm, s.orderNumber)">validate</button>
                                                        <button *ngIf="s.stillWrong" mdbBtn color="warning" type="button" outline="true"
                                                            rounded="true" size="sm" mdbWavesEffect [disabled]="!vm.actionsAllowed"
                                                            (click)="mismatchIgnoreClick(vm, s.orderNumber, 1)">Ignore</button>
                                                        <mdb-badge class="align-self-center" *ngIf="s.cmdExecutedErrorText" pill="true"
                                                            danger="true" [mdbTooltip]="s.cmdExecutedErrorText">!</mdb-badge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-card-body>
                                </mdb-card>
                            </div>            
                        </div>
                    </mdb-tab>

                    <!-- booked, pending crossroads confirm -->
                    <mdb-tab heading="Pending" *ngIf="vm.data.pendingOrderPanel as p">
                        <div class="row">
                            <div class="col-md-6 animated fadeIn pb-3" *ngFor="let s of p.sections">
                                <mdb-card narrower="true" cascade="true">
                                    <app-card-header [title]="s.orderNumber" [headingSize]="3" [subTitle]="s.subTitle"
                                        [dangerText]="s.dangerText" [warningText]="s.warningText"></app-card-header>
                                    <mdb-card-body cascade="true">
                                        
                                        <div class="row">
                                            <div class="col-md-4">
                                                <a href="{{s.crossroadsUrl}}" target="_blank">View Order</a>
                                            </div>
                                            <div class="col-md-4">
                                                <span>{{s.confirmNumber}}</span>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <table mdbTable striped="true" small="true">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Field</th>
                                                            <th scope="col">Santa Cruz</th>
                                                        </tr>
                                                    </thead>
                
                                                    <tbody>
                                                        <tr mdbTableCol *ngFor="let f of s.fields">
                                                            <td>{{f.name}}</td>
                                                            <td>{{f.santaCruzValue}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </mdb-card-body>
                                </mdb-card>
                            </div>
                        </div>
                    </mdb-tab>


                    <!-- new order -->
                    <mdb-tab heading="New" *ngIf="vm.data.newOrderPanel as p">
                        <div class="row">
                            <div class="col-md-6 animated fadeIn pb-3" *ngFor="let s of p.sections">
                                <mdb-card narrower="true" cascade="true">
                                    <app-card-header [title]="s.orderNumber" [headingSize]="3" [subTitle]="s.subTitle"
                                        [dangerText]="s.dangerText"></app-card-header>
                                    <mdb-card-body cascade="true">
                                        
                                        <div class="row">
                                            <div class="col-md-4">
                                                <a href="{{s.crossroadsUrl}}" target="_blank">View Order</a>
                                            </div>
                                            <div class="col-md-4">
                                                <span>{{s.confirmNumber}}</span>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <table mdbTable striped="true" small="true">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Field</th>
                                                            <th scope="col">Crossroads</th>
                                                        </tr>
                                                    </thead>
                
                                                    <tbody>
                                                        <tr mdbTableCol *ngFor="let f of s.fields">
                                                            <td>{{f.name}}</td>
                                                            <td>{{f.crossroadsValue}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </mdb-card-body>
                                </mdb-card>
                            </div>
                        </div>
                    </mdb-tab>
            
                    <!-- timezone -->
                    <mdb-tab heading="Time Zone" *ngIf="vm.timeZoneIssuesVm as tzvm">
                        <div class="row">
                            <div class="col-md-12 animated fadeIn">
                                <span *ngIf="!tzvm.rows.length">No issues at the moment!</span>

                                <table *ngIf="tzvm.rows.length" mdbTable striped="true" small="true">
                                    <thead>
                                        <tr>
                                            <th scope="col" *ngFor="let c of tzvm.data.columns">{{c}}</th>
                                            <th></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr mdbTableCol *ngFor="let r of tzvm.rows">
                                            <td *ngFor="let f of r.fields">{{f}}</td>
                                            <td style=" width:150px; ">
                                                <div class="d-flex align-items-center" style="height: 50px;">
                                                    <div *ngIf="r.completedText">
                                                        <mdb-badge pill="true" success="true">{{r.completedText}}
                                                        </mdb-badge>
                                                    </div>
                                                    <div *ngIf="r.cmdExecutingText"
                                                        class="d-flex justify-content-start">
                                                        <span>{{r.cmdExecutingText}}</span>
                                                    </div>
                                                    <div *ngIf="!r.completedText && !r.cmdExecutingText"
                                                        class="d-flex justify-content-start">
                                                        <button mdbBtn [disabled]="!vm.actionsAllowed" color="default"
                                                            type="button" outline="true" rounded="true" size="sm"
                                                            mdbWavesEffect
                                                            (click)="timeZoneValidateClick(vm, r.airportCode)">{{r.cmdExecutingText
                                                            || 'validate'}}
                                                        </button>
                                                        <mdb-badge class="align-self-center"
                                                            *ngIf="r.cmdExecutedErrorText" danger="true"
                                                            [mdbTooltip]="r.cmdExecutedErrorText">!</mdb-badge>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>

                        <div class="row pt-3" *ngIf="vm.airportMappingEntryVm as amevm">
                            <div class="col-md-12 animated fadeIn">
                                <h5 class="mb-0 pb-0">Airport Mapping</h5>
                                <form class="mt-0 pt-0">
                                    <div class="form-row">
                                        <div class="col-md-3">
                                            <div class="md-form form-group">
                                                <input mdbInput type="text" class="form-control" name="iata" id="iata" [(ngModel)]="amevm.data.iataCode">
                                                <label for="iata">IATA</label>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="md-form form-group">
                                                <input mdbInput type="text" class="form-control" name="icao" id="icao" [(ngModel)]="amevm.data.icaoCode">
                                                <label for="icao">ICAO</label>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="md-form form-group">
                                                <input mdbInput type="text" class="form-control" name="faa" id="faa" [(ngModel)]="amevm.data.faaCode">
                                                <label for="faa">FAA</label>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="md-form form-group">
                                                <button [disabled]="!vm.actionsAllowed" rounded="true" type="submit"
                                                    (click)="airportMappingSaveClick(vm)"
                                                    size="sm" outline="true" mdbBtn color="success">{{amevm.cmdExecutingText
                                                        || 'save'}}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row" *ngIf="amevm.cmdExecutedErrorText || amevm.completedText">
                                        <div class="col-md-12">
                                            <span *ngIf="amevm.cmdExecutedErrorText" class="text-danger">{{amevm.cmdExecutedErrorText}}</span>
                                            <span *ngIf="amevm.completedText" class="text-success">{{amevm.completedText}}</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </mdb-tab>

                    <!-- in-position -->
                    <mdb-tab heading="In Position" *ngIf="vm.inPositionIssuesVm as ipvm">
                        <div class="row">
                            <div class="col-md-12 animated fadeIn">
                                <table mdbTable striped="true" small="true">
                                    <thead>
                                        <tr>
                                            <th scope="col">Order Number</th>
                                            <th scope="col">Dates</th>
                                            <th></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr mdbTableCol *ngFor="let r of ipvm.rows">
                                            <td>
                                                <div class="mb-2">
                                                    {{r.fields[0]}}
                                                </div>
                                                <div>
                                                    {{r.fields[1]}}
                                                </div>
                                            </td>
                                            <td>
                                                <div class="mb-2">
                                                    OL - {{r.fields[3] | date:'short'}}
                                                </div>
                                                <div>
                                                    PU - {{r.fields[2] | date:'short'}}
                                                </div>
                                            </td>
                                            <td style=" width:150px; ">
                                                <div class="d-flex align-items-center" style="height: 50px;">
                                                    <div *ngIf="r.completedText">
                                                        <mdb-badge pill="true" success="true">{{r.completedText}}
                                                        </mdb-badge>
                                                    </div>
                                                    <div *ngIf="r.cmdExecutingText"
                                                        class="d-flex justify-content-start">
                                                        <span>{{r.cmdExecutingText}}</span>
                                                    </div>
                                                    <div *ngIf="!r.completedText && !r.cmdExecutingText"
                                                        class="d-flex justify-content-start">
                                                        <button mdbBtn [disabled]="!vm.actionsAllowed" color="default"
                                                            type="button" outline="true" rounded="true" size="sm"
                                                            mdbWavesEffect
                                                            (click)="inPositionViewClick(vm, r.fields[0])">{{r.cmdExecutingText
                                                            || 'view'}}
                                                        </button>
                                                        <mdb-badge class="align-self-center"
                                                            *ngIf="r.cmdExecutedErrorText" danger="true"
                                                            [mdbTooltip]="r.cmdExecutedErrorText">!</mdb-badge>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </mdb-tab>

                </mdb-tabset>
            </div>

        </div>

    </div>

</div>